import React from 'react'

// ArComponents
import ArHeroHeader from 'src/components/ArHeroHeader/ArHeroHeader'
import ArLocations from 'src/components/ArLocations/ArLocations'
import ArSeo from 'src/components/ArSeo/ArSeo'

// Data
import DaPageContact from 'src/data/PageContact'
import routesConfig from 'src/routes.config'

class ContactPage extends React.Component {
  render () {
    return (
      <React.Fragment>

        <ArSeo
          title={DaPageContact.metadata.title}
          description={DaPageContact.metadata.desc}
          path={routesConfig.contact()}
        />

        {(() => {
          const { title, description, form } = DaPageContact.ArHeroHeader
          return (
            <ArHeroHeader
              variant="contact"
              form={form}
              title={title}
              description={description}
            />
          )
        })()}

        {(() => {
          const { title, description, locations } = DaPageContact.ArLocations

          return (
            <ArLocations
              title={title}
              description={description}
              locations={locations}
            />
          )
        })()}

      </React.Fragment>
    )
  }
}

export default ContactPage
